import { CustomExamQuestionResult } from '../api-results/custom-exam-question.api-result';
import { ContentQuestion } from './content-question.entity';
import { Question } from './question.entity';

export class ChallengeQuestion extends ContentQuestion {}
